import axios from "axios";
import config from "../../config.json";

const authHeaders = () => ({
  Authorization: `Bearer ${localStorage.getItem("tokenLogin")}`,
});

const baseUrl = `${config.dev}/v2/admin-history`;

export async function fetchAdminActionLogs({
  page = 1,
  limit = 10,
  search = "",
  action = "",
  dateFrom = "",
  dateTo = "",
  sortBy = "date_desc",
  archived = false,
} = {}) {
  const response = await axios.get(`${baseUrl}/retrieve`, {
    headers: authHeaders(),
    params: {
      page,
      limit,
      sortBy,
      archived: archived ? "true" : "false",
      ...(search ? { search } : {}),
      ...(action ? { action } : {}),
      ...(dateFrom ? { dateFrom } : {}),
      ...(dateTo ? { dateTo } : {}),
    },
  });
  return response.data;
}

export async function fetchAdminActionTypes({ archived = false } = {}) {
  const response = await axios.get(`${baseUrl}/actions`, {
    headers: authHeaders(),
    params: {
      archived: archived ? "true" : "false",
    },
  });
  return response.data;
}

export async function archiveAdminActionLog(id) {
  const response = await axios.put(
    `${baseUrl}/archive/${id}`,
    {},
    { headers: authHeaders() }
  );
  return response.data;
}

export async function restoreAdminActionLog(id) {
  const response = await axios.put(
    `${baseUrl}/restore/${id}`,
    {},
    { headers: authHeaders() }
  );
  return response.data;
}

export async function deleteAdminActionLog(id) {
  const response = await axios.delete(`${baseUrl}/delete/${id}`, {
    headers: authHeaders(),
  });
  return response.data;
}

/**
 * Fire-and-forget helper for client-side modules (plan floor setups, etc.).
 * Never throws to callers.
 */
export async function logAdminHistoryAction({
  action,
  description = "",
  metadata = null,
} = {}) {
  try {
    if (!action) return null;
    const response = await axios.post(
      `${baseUrl}/log`,
      { action, description, metadata },
      { headers: authHeaders() }
    );
    return response.data;
  } catch (error) {
    console.error("[logAdminHistoryAction]", error?.message || error);
    return null;
  }
}
